import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CloudIcon, LayoutGridIcon, RefreshCwIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-cream py-24 px-6" data-id="element-110">
      <div className="max-w-4xl mx-auto text-center" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-113">
            A Simpler Way to Understand Smartphones.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-114">
          <p className="text-lg md:text-xl text-charcoal/80 mb-16 leading-relaxed" data-id="element-115">
            This guide doesn't use "tech-speak." By using metaphors from the
            world they already know, their brain finally clicks into place.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-116">
          <FadeIn delay={0.3} data-id="element-117">
            <div className="bg-white p-8 rounded-2xl shadow-sm h-full flex flex-col items-center text-center" data-id="element-118">
              <div className="bg-sage-light p-4 rounded-full mb-6" data-id="element-119">
                <CloudIcon className="w-8 h-8 text-sage" data-id="element-120" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-121">The Cloud</h3>
              <p className="text-warmBrown font-medium" data-id="element-122">
                Explained as a bank's safety deposit box.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-123">
            <div className="bg-white p-8 rounded-2xl shadow-sm h-full flex flex-col items-center text-center" data-id="element-124">
              <div className="bg-amber-light/50 p-4 rounded-full mb-6" data-id="element-125">
                <LayoutGridIcon className="w-8 h-8 text-amber" data-id="element-126" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-127">Apps</h3>
              <p className="text-warmBrown font-medium" data-id="element-128">
                Treated like tools in a kitchen drawer.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-129">
            <div className="bg-white p-8 rounded-2xl shadow-sm h-full flex flex-col items-center text-center" data-id="element-130">
              <div className="bg-warmGray p-4 rounded-full mb-6" data-id="element-131">
                <RefreshCwIcon className="w-8 h-8 text-charcoal" data-id="element-132" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-133">Updates</h3>
              <p className="text-warmBrown font-medium" data-id="element-134">
                Explained as a simple oil change for a car.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}